import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportesRequestService {

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  private IMAGES_API = '';

  private FILTROS_API = '';

  private REPORTES_API = '';

  private HISTORIA_API = '';

  constructor( private http: HttpClient ) {
    this.IMAGES_API = environment.API_IMAGENES;
    this.FILTROS_API = environment.API_FILTROS;
    this.REPORTES_API = environment.API_REPORTES;
    this.HISTORIA_API = environment.API_HISTORIA;
  }

  /*
    Este método tiene la ruta principal de los servicios, la cual
    enrutará al servicio necesario, dependiendo de la petición del cliente.
  */
  public getRequest( request: string, params: any [] ) {
    const URL = `${this.REPORTES_API}/${ request }`;


    return this.http.post(
      URL,
      {
        'codigoBaseDatos' : params[0],
        'parametrosFiltros' : params[1]
      },
      { headers : this.HEADERS }
    );


  }

  public getFilterRequest( request: string, params: any[] ) {
    const URL = `${this.FILTROS_API}/${ request }`;
    return this.http.post(
      URL,
      {
        'codigoBaseDatos' : params[0],
        'parametrosFiltros' : params[1] ? params[1] : null
      },
      { headers : this.HEADERS }
    );
  }

  public getFilterRequestGet( request: string, params: any[] ) {
    const URL = `${this.FILTROS_API}/${ request }`;
    return this.http.get(
      URL,
      { headers : this.HEADERS }
    );
  }

  public getImagesRequest( request: string, params: any[]) {
    const URL = `${this.IMAGES_API}/${request}`;
    return this.http.post(
      URL,
      {
        'codigoBaseDatos' : params[0],
        'parametrosFiltros' : params[1] ? params[1] : null
      },
      { headers : this.HEADERS }
    );
  }


  public getHistoria( request: string, params: any[] ) {
    const URL = `${this.HISTORIA_API}/${request}`;
    return this.http.post(
      URL,
      {
        'codigoBaseDatos' : params[0],
        'id' : params[1]
      },
      { headers : this.HEADERS }
    );
  }

}
